__turbopack_context__.v({
  "animate": "Graph-module-scss-module__70WVUW__animate",
  "animate-bar": "Graph-module-scss-module__70WVUW__animate-bar",
  "barColumn": "Graph-module-scss-module__70WVUW__barColumn",
  "barWrapper": "Graph-module-scss-module__70WVUW__barWrapper",
  "barWrapper1": "Graph-module-scss-module__70WVUW__barWrapper1",
  "barWrapper2": "Graph-module-scss-module__70WVUW__barWrapper2",
  "barWrapper3": "Graph-module-scss-module__70WVUW__barWrapper3",
  "chartBar": "Graph-module-scss-module__70WVUW__chartBar",
  "chartInner": "Graph-module-scss-module__70WVUW__chartInner",
  "chartRow": "Graph-module-scss-module__70WVUW__chartRow",
  "copyWrapper": "Graph-module-scss-module__70WVUW__copyWrapper",
  "fade-in": "Graph-module-scss-module__70WVUW__fade-in",
  "headline": "Graph-module-scss-module__70WVUW__headline",
  "headlineWrapper": "Graph-module-scss-module__70WVUW__headlineWrapper",
  "icon": "Graph-module-scss-module__70WVUW__icon",
  "iconWrapper": "Graph-module-scss-module__70WVUW__iconWrapper",
  "innerChart": "Graph-module-scss-module__70WVUW__innerChart",
  "lockup": "Graph-module-scss-module__70WVUW__lockup",
  "percentWrapper": "Graph-module-scss-module__70WVUW__percentWrapper",
  "percentage": "Graph-module-scss-module__70WVUW__percentage",
  "yearLabel": "Graph-module-scss-module__70WVUW__yearLabel",
  "yearLabelWrapper": "Graph-module-scss-module__70WVUW__yearLabelWrapper",
});
